import { Controller } from '@hotwired/stimulus'
import Toast from '/libs/toast'
import { i18n } from '/libs/i18n'

export default class extends Controller {

  async copy({ params: { content, selector } }) {

    if (!content) {
      const node = this.element.querySelector(selector)
      content = this.element.querySelector(selector)?.innerText
    }

    try {
      await navigator.clipboard.writeText(content)
      this.success()
    } catch (error) {
      this.error()
      console.error(i18n.t('clipboard.error', error))
    }
  }

  async richCopy({ params: { selector } }) {
    const node = this.element.querySelector(selector)

    if (!node) { this.error(); return }

    try {
      const clipboardItem = new ClipboardItem({
        'text/plain': new Blob(
          [node.innerText],
          { type: 'text/plain' }
        ),
        'text/html': new Blob(
          [node.innerHTML],
          { type: 'text/html' }
        ),
      })
      await navigator.clipboard.write([clipboardItem])
      this.success()
    } catch (error) {
      if (error instanceof ReferenceError)
        this.error('Firefox => Mettre dom.events.asyncClipboard.clipboardItem à true dans about:config')
      else
        this.error()
      console.error(i18n.t('js.clipboard.error', error))
    }
  }

  success() {
    new Toast(i18n.t('js.clipboard.success'), { type: 'notice' }).show()
  }

  error(message='Erreur !') {
    new Toast(message, { type: 'alert' }).show()
  }
}
